export default __webpack_public_path__ + "static/media/naranja.0e2deca4.jpeg";